import { Controller } from "@hotwired/stimulus"

// The Feedback Loop page's two tabs (Phelipe 2026-10-16): Requests (the list
// as it was) and Studio changes. Both panels stay inside the page's
// feedback-list / feedback-review scope, so hiding one breaks nothing.
// `?tab=studio` opens the second one; picking a tab rewrites the address so
// a refresh keeps it.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { active: String }

  connect() {
    const wanted = new URL(window.location.href).searchParams.get("tab")
    this.show(wanted === "studio" ? "studio" : (this.activeValue || "loop"), false)
  }

  pick(e) { this.show(e.currentTarget.dataset.tab, true) }

  show(name, remember) {
    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.tab === name
      tab.setAttribute("aria-selected", String(on))
      tab.classList.toggle("border-brand", on)
      tab.classList.toggle("text-brand-dark", on)
      tab.classList.toggle("font-semibold", on)
      tab.classList.toggle("border-transparent", !on)
      tab.classList.toggle("text-gray-500", !on)
    })
    this.panelTargets.forEach((panel) => { panel.hidden = panel.dataset.tab !== name })
    if (!remember) return
    const url = new URL(window.location.href)
    if (name === "studio") url.searchParams.set("tab", "studio"); else url.searchParams.delete("tab")
    window.history.replaceState({}, "", url)
  }
}
